(function() {
  'use strict';

  ResizableColumn.$inject = ["$document", "PATH"];
  app.directive('resizableColumn', ResizableColumn);

  function ResizableColumn($document, PATH) {
    /**
     * TableView - directive show table
     *
     * @param  {String} sourceType - optional load, loadPerPage or datasource, datasource by default
     * @param  {Object} options - contains header object with width and
     *              options = {
     *                          @param  {Object} header - table header object with column sizes
     *                          @param  {Number} columnMinWidth - min column width
     *                          @param  {Number} columnMaxWidth - max column width
     *                          @param  {Number} clientWidth - table-view element client width
     *                        }
     * @param  {Number} index - column index
     * @param  {Number} isLast - is column last
     * @param  {Function} onResize: - event hendler on column size changed
     */
    return {
      replace: true,
      scope: {
        isResizable: '=resizable',
        options: '=',
        index: '=',
        isLast: '=',
        onResize: '&',
        refreshColumnsWidth: '&'
      },
      restrict: 'E',
      link: link
    };

    function link($scope, $element, $attrs) {
      var handle, prevScreenX, onResize, actions;

      onResize = _.throttle($scope.onResize, 100);

      handle = angular.element(
        "<span class='table-view__header-resize-handle' title='Resize'></span>"
      );

      if ($scope.isResizable && (!$scope.isLast)) {
        handle.addClass('mod-resizable');
      }

      /**
       * onResizeMouseClick - on resize element mouse click
       *
       * @param  {Object} event  mouse click event
       */
      handle.on('mousedown', function (event) {
        if (!event.target.classList.contains('mod-resizable')) {
          return false;
        }

        $scope.refreshColumnsWidth();

        event.stopPropagation();
        event.preventDefault();

        $document.on('mousemove', onMouseMove);
        $document.on('mouseup', onMouseUp);
      });

      /**
       * onMouseMove - on resize column mouse move event
       *
       * @param  {Object} event  mouse move event
       */
      function onMouseMove(event) {
        var movementX, delta, prevWidth, nextWidth;
        event = event.originalEvent || event;
        movementX = event.movementX || event.mozMovementX || (event.screenX - prevScreenX);
        delta = (movementX || 0);
        prevWidth = $scope.options.header[$scope.index].width + delta;
        nextWidth = $scope.options.header[$scope.index + 1].width - delta;

        prevScreenX = event.screenX;

        if ((!$scope.options.columnMinWidth || prevWidth >= $scope.options.columnMinWidth)
          && (!$scope.options.columnMaxWidth || prevWidth <= $scope.options.columnMaxWidth)
          && (!$scope.options.columnMinWidth || nextWidth >= $scope.options.columnMinWidth)
          && (!$scope.options.columnMaxWidth || nextWidth <= $scope.options.columnMaxWidth)) {
          $scope.options.header[$scope.index].width = prevWidth;
          $scope.options.header[$scope.index + 1].width = nextWidth;
          onResize($scope.options.header);
        }
      }

      /**
       * onMouseUp - on resize column mouse up event
       */
      function onMouseUp() {
        $document.unbind('mousemove', onMouseMove);
        $document.unbind('mouseup', onMouseUp);
        onResize($scope.options.header);
      }

      $element.append(handle);
    }
  }
})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/tableView/resizableColumn/directive.js